const prod = {
  API_URL: 'https://parts.robotigers1796.com',
};
const dev = {
  API_URL: 'http://localhost:5000',
};

export const subSystemSelectables = [
  {
    label: 'Chassis',
    value: 'Chassis',
  },
  {
    label: 'Climb',
    value: 'Climb',
  },
  {
    label: 'Drivetrain',
    value: 'Drivetrain',
  },
  {
    label: 'Elevator',
    value: 'Elevator',
  },
  {
    label: 'Feeder',
    value: 'Feeder',
  },
  {
    label: 'Hopper',
    value: 'Hopper',
  },
  {
    label: 'Intake',
    value: 'Intake',
  },
  {
    label: 'Shooter',
    value: 'Shooter',
  },
  {
    label: 'Scoring Delivery',
    value: 'Scoring Delivery',
  },
  {
    label: 'Miscellaneous',
    value: 'Miscellaneous',
  },
];

export const materialSelectables = [
  {
    label: 'Al-5052 (Bent)',
    options: [
      {
        label: 'Al-5052 0.060"',
        value: 'Al-5052 0.060"',
      },
      {
        label: 'Al-5052 0.080"',
        value: 'Al-5052 0.080"',
      },
      {
        label: 'Al-5052 0.120"',
        value: 'Al-5052 0.120"',
      },
      {
        label: 'Al-5052 0.250"',
        value: 'Al-5052 0.250"',
      },
    ],
  },
  {
    label: 'Al-6061 (Flat)',
    options: [
      {
        label: 'Al-6061 0.060"',
        value: 'Al-6061 0.060"',
      },
      {
        label: 'Al-6061 0.080"',
        value: 'Al-6061 0.080"',
      },
      {
        label: 'Al-6061 0.120"',
        value: 'Al-6061 0.120"',
      },
      {
        label: 'Al-6061 0.250"',
        value: 'Al-6061 0.250"',
      },
    ],
  },
  {
    label: 'Stainless Steel Sheet (304)',
    options: [
      {
        label: 'SSS 0.060"',
        value: 'SSS 0.060"',
      },
      {
        label: 'SSS 0.072"',
        value: 'SSS 0.072"',
      },
      {
        label: 'SSS 0.120"',
        value: 'SSS 0.120"',
      },
      {
        label: 'SSS 0.250"',
        value: 'SSS 0.250"',
      },
    ],
  },
  {
    label: 'Clear Polycarbonate',
    options: [
      {
        label: 'Clear Polycarbonate 0.060"',
        value: 'Clear Polycarbonate 0.060"',
      },
      {
        label: 'Clear Polycarbonate 0.120"',
        value: 'Clear Polycarbonate 0.120"',
      },
      {
        label: 'Clear Polycarbonate 0.250"',
        value: 'Clear Polycarbonate 0.250"',
      },
    ],
  },
  {
    label: 'Tint Gray Polycarbonate',
    options: [
      {
        label: 'Tint Gray Polycarbonate 0.060"',
        value: 'Tint Gray Polycarbonate 0.060"',
      },
      {
        label: 'Tint Gray Polycarbonate 0.120"',
        value: 'Tint Gray Polycarbonate 0.120"',
      },
      {
        label: 'Tint Gray Polycarbonate 0.250"',
        value: 'Tint Gray Polycarbonate 0.250"',
      },
    ],
  },
  {
    label: 'Opaque Black Polycarbonate',
    options: [
      {
        label: 'Opaque Black Polycarbonate 0.060"',
        value: 'Opaque Black Polycarbonate 0.060"',
      },
      {
        label: 'Opaque Black Polycarbonate 0.120"',
        value: 'Opaque Black Polycarbonate 0.120"',
      },
      {
        label: 'Opaque Black Polycarbonate 0.250"',
        value: 'Opaque Black Polycarbonate 0.250"',
      },
    ],
  },
];

export const mfrProcessSelectables = [
  {
    label: 'Laser Cut',
    value: 'Laser Cut',
  },
  {
    label: 'Hurco CNC',
    value: 'Hurco CNC',
  },
  {
    label: 'Water Jet',
    value: 'Water Jet',
  },
  {
    label: 'Bend',
    value: 'Bend',
  },
];

export const finishSelectables = [
  {
    label: 'None',
    value: 'None',
  },
  {
    label: 'Paint',
    options: [
      {
        label: 'RT Green Paint',
        value: 'RT Green Paint',
      },
      {
        label: 'Gloss Black Paint',
        value: 'Gloss Black Paint',
      },
      {
        label: 'Matte Black Paint',
        value: 'Matte Black Paint',
      },
      {
        label: 'Gloss White Paint',
        value: 'Gloss White Paint',
      },
    ],
  },
  {
    label: 'Anodize',
    options: [
      {
        label: 'Anodized Black',
        value: 'Anodized Black',
      },
      {
        label: 'Anodized Hardened Black',
        value: 'Anodized Hardened Black',
      },
    ],
  },
];

export const prioritySelectables = [
  {
    label: 'Low',
    value: '4',
  },
  {
    label: 'Medium',
    value: '3',
  },
  {
    label: 'High',
    value: '2',
  },
  {
    label: 'National Emergency',
    value: '1',
  },
];
export const config = process.env.NODE_ENV === 'development' ? dev : prod;
